"use client";

import { MonitoringRuntime } from "@repo/monitoring";
import {
  amcPdpComponentRenderMonitors,
  amcPdpMonitoringSchema,
} from "@repo/amc-pdp-libs/monitoring";

export default function MonitoringSetup() {
  return (
    <MonitoringRuntime
      schema={amcPdpMonitoringSchema}
      componentMonitors={amcPdpComponentRenderMonitors}
      interactionOptions={{
        responseWindowMs: 2000,
        rageClickWindowMs: 2500,
        rageClickThreshold: 3,
      }}
    />
  );
}
